import { useReducer } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { identityReducer } from '../utilities/identityReducer'
import { IFormValues, initialState } from '../utilities/initialValues'
import { useFormContextData } from 'pages/authenticationUsers/contexts'

const useIdentityVerification = () => {
    const navigate = useNavigate()
    const { setFormData } = useFormContextData()
    const [state, dispatch] = useReducer(identityReducer, initialState)

    const { selectedFile, isModalOpen, tempFile } = state

    const handleSubmit = async (values: IFormValues) => {
        if (!selectedFile) {
            toast.error('بارگذاری عکس کارت ملی الزامی است')
            return
        }

        const formData = new FormData()
        formData.append('nationalCode', values.nationalCode)
        formData.append('phoneNumber', values.phoneNumber)
        formData.append('serialCode', values.serialCode)
        formData.append('nationalCardPhoto', selectedFile)

        try {
            setFormData((prevData) => ({
                ...prevData,
                nationalCode: values.nationalCode,
                phoneNumber: values.phoneNumber,
                serialCode: values.serialCode,
                nationalCardPhoto: selectedFile,
            }))

            toast.success('اطلاعات با موفقیت ثبت شد')
            navigate('/authentication-user/photo-capture')
        } catch (error) {
            toast.error('خطا در ثبت اطلاعات. لطفا دوباره تلاش کنید')
        }
    }

    const handleOpenModal = () => {
        dispatch({ type: 'SET_MODAL_OPEN', payload: true })
        dispatch({ type: 'SET_TEMP_FILE', payload: selectedFile })
    }

    const handleCloseModal = () => {
        dispatch({ type: 'SET_TEMP_FILE', payload: null })
        dispatch({ type: 'SET_MODAL_OPEN', payload: false })
    }

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null
        dispatch({ type: 'SET_TEMP_FILE', payload: file })
    }

    const handleConfirm = (setFieldValue: any) => {
        dispatch({ type: 'SET_SELECTED_FILE', payload: tempFile })
        setFieldValue('nationalCardPhoto', tempFile)
        setFormData((prevData) => ({
            ...prevData,
            nationalCardPhoto: tempFile,
        }))
        dispatch({ type: 'SET_MODAL_OPEN', payload: false })
    }

    const handleChangePhoto = () => {
        document.getElementById('fileInput')?.click()
    }

    return {
        state,
        handleSubmit,
        handleOpenModal,
        handleCloseModal,
        handleFileSelect,
        handleConfirm,
        handleChangePhoto,
    }
}

export default useIdentityVerification
